import { IGetOfficePlanDetailResult } from '../types';
import { PostingPlanAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';

export const getOfficePlanDetail = async (planId: string): Promise<IGetOfficePlanDetailResult> => {
  const response = await PermanentJobsApi.getOfficePlanDetail(planId);

  return PostingPlanAdapters.toGetOfficePlanDetailResult(response);
};
